import { Configuration } from "@seriously-rad/seriouslyrad-framework-core/Configuration";
import { WindowShim } from "@seriously-rad/seriouslyrad-framework-core/RadWindow";
import { registerPageManagerConfiguration } from "@seriously-rad/seriouslyrad-framework-core/Registration";
import { EntityCommandIntegratedDataSetRecordFilter } from "./EntityCommands/EntityCommandIntegratedDataSetRecordFilter";
import { EntityCommandIntegratedDataSetRecordLogEntryFilter } from "./EntityCommands/EntityCommandIntegratedDataSetRecordLogEntryFilter";
import { EntityCommandIntegratedDataSetRecordLogEntryOpen } from "./EntityCommands/EntityCommandIntegratedDataSetRecordLogEntryOpen";
import pageManagerConfiguration from "./Ui/PageManagerConfiguration";

const
    radWindow = WindowShim();

export async function registerModuleIntegrationsAsync(configuration: Configuration)
{
    // Integrated Data Set Record
    radWindow.entityManager?.registerCommand(new EntityCommandIntegratedDataSetRecordFilter());

    // Integrated Data Set Record Log Entry
    radWindow.entityManager?.registerCommand(new EntityCommandIntegratedDataSetRecordLogEntryFilter());
    radWindow.entityManager?.registerCommand(new EntityCommandIntegratedDataSetRecordLogEntryOpen());

    registerPageManagerConfiguration(configuration, pageManagerConfiguration);
}